<template>
<section class="position-relative">
  <div class="bg-element text-element">
    &lt;code/&gt;
  </div>
  <div class="container">
    <div class="row align-items-lg-center justify-content-center justify-content-md-between">
      <div class="col-10 col-md-6 col-lg-5 mb-5 mb-lg-0">
        <div class="img-wrapper round-img border-gradient box-shadow-light">
          <img :src="portfolioImage" alt="Mmatovski's Profile Picture" title="Mmatovski's Profile Picture" class="img-fluid" />
        </div>
      </div>
      <div class="col-md-6 text-center text-md-start">
        <h3 class="h3 mb-2 mb-md-3">
          {{ topTitle }}
          <img src="@/assets/img/yoda-icon.svg" alt="Icon" title="Icon" class="title-icon animation-up-down" />
        </h3>
        <h1 class="section-title h1 font-gradient mb-2 mb-md-3">{{ title }}</h1>
        <p class="h3">{{ bottomTitle }}</p>
        <div class="btn-wrapper mt-4 mt-lg-5">
          <a :href="linkedin" class="btn btn-primary me-3" target="_blank">Check my resume <i class="las la-mouse"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
import portfolioImage from '@/assets/img/portfolio-image.jpg'

export default {
  name: 'StartingComponent',
  components: {
  },
  data () {
    return {
      topTitle: 'Martin I am',
      title: 'A Full-Stack Web Developer',
      bottomTitle: 'Or am I? It\'s up to you to find out!',
      linkedin: 'https://www.linkedin.com/in/martin-matovski-21b965150/',
      portfolioImage: portfolioImage
    }
  },
  methods: {
  }
}
</script>
